module.exports = __webpack_public_path__ + "static/caterpillar-mobile-16847c4209f6723e2edd13997778f157.svg";